// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext, useEffect, useMemo,
    useState} from 'react';
import {Settings_context} from '../../../hola/pub/settings_ctx';
import cn from 'classnames';
import {Switch_slider} from '../ui/switch_slider';
import {Full_page_slider} from '../ui/full_page_slider';
import {Pricing_slide} from '../ui/pricing_slide';
import {use_screen} from '../../../hola/pub/lib/screen_util';
// @ts-ignore
import {Tooltip} from '../../../hola/pub/lib/tooltip';
import styles from './pricing_widget.module.less';
import {use_translation_v} from '../../../hola/pub/lib/trans_v';
import {Editor} from '../../../shared/editor/editor';
import {Dynamic_heading} from '../../../shared/editor/title_header_select';

export type t_pricing_widget_type = 'isp'|'shared_dc'|'dedicated_dc'|'isp_plus'
    |'smart_resi';

interface i_props_pricing_widget {
    type_slider?: boolean;
    cms_mode?: boolean;
    def_type?: t_pricing_widget_type;
    best_type?: t_pricing_widget_type;
    best_label?: JSX.Element|string;
    arrow_direction?: 'left'|'right'|'down';
    title?: string | JSX.Element;
    title_tag?: string;
    subtitle?: string | JSX.Element;
    with_faq?: boolean;
    with_need_help?: boolean;
    with_other_products?: boolean;
    with_isp_toggle?: boolean;
    cls?: string;
    sliders_pos?: 'left' | 'center' | 'right';
}

type i_use_widget_props = Pick<
    i_props_pricing_widget,
    'def_type' | 'with_faq' | 'with_need_help' | 'with_other_products' |
    'best_type' | 'with_isp_toggle'
> & {
    width?: number;
};

const use_widget = (props: i_use_widget_props)=>{
    const {def_type, with_faq, with_need_help,
      best_type, with_isp_toggle, with_other_products, width} = props;
    const types_data = [{
        text: 'Shared Datacenter Proxies',
        id: 'shared_dc',
        active_color: 'var(--wp--preset--color--blue-200)',
    }, {
        text: 'Dedicated Datacenter Proxies',
        id: 'dedicated_dc',
        active_color: 'var(--wp--preset--color--brown-200)',
    }, {
        text: 'Static Residential Proxies',
        id: 'isp_plus',
        active_color: 'var(--wp--preset--color--green-200)',
    }, {
        text: 'Rotating Residential Proxies',
        id: 'smart_resi',
        active_color: 'var(--wp--preset--color--purple-200)',
    }];
    const slider_data = useMemo(()=>{
        return [{
          text: 'Shared Datacenter Proxies',
          id: 'shared_dc',
          content:
        <Pricing_slide id={'shared_dc'} color={'blue'}
          btn_text={'Buy now'} prod_details={['SOCKS5 support',
            '99.99% uptime', '20GB limit per IP', 'Huge pool of IPs',
            'Flat fees, no hidden costs']} with_faq={with_faq}
          with_need_help={with_need_help}
          with_other_products={with_other_products}
          popular_bg={'var(--wp--preset--color--brown-200)'}
          popular_color={'var(--wp--preset--color--neutrals-600)'}
          def_type={def_type}/>,
        }, {
          text: 'Dedicated Datacenter Proxies',
          id: 'dedicated_dc',
          content:
        <Pricing_slide id={'dedicated_dc'} color={'brown'}
          btn_text={'Buy now'} prod_details={['SOCKS5 support',
            '99.99% uptime', '20GB limit per IP', 'Exclusively yours',
            'Flat fees, no hidden costs']} with_faq={with_faq}
          with_need_help={with_need_help}
          with_other_products={with_other_products}
          popular_bg={'var(--wp--preset--color--blue-100)'}
          popular_color={'var(--wp--preset--color--blue-400)'}
          def_type={def_type}/>,
        }, {
          text: 'Static Residential Proxies',
          id: 'isp_plus',
          content:
        <Pricing_slide id={'isp_plus'} color={'green'}
          btn_text={'Buy now'} prod_details={['SOCKS5 support',
            '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs', 'Flat fees, no hidden costs']}
          include_google={true} with_faq={with_faq}
          with_need_help={with_need_help}
          with_other_products={with_other_products}
          popular_bg={'var(--wp--preset--color--pink-200)'}
          popular_color={'var(--wp--preset--color--green-700)'}
          def_type={def_type} with_isp_toggle={with_isp_toggle}/>,
        }, {
          id: 'isp',
          content:
        <Pricing_slide id={'isp'} color={'green'}
          btn_text={'Buy now'} prod_details={['SOCKS5 support',
            '99.99% uptime', 'Unlimited bandwidth',
            'Real Static Residential IPs', 'Flat fees, no hidden costs']}
          include_google={true} with_faq={with_faq}
          with_need_help={with_need_help}
          with_other_products={with_other_products}
          popular_bg={'var(--wp--preset--color--pink-200)'}
          popular_color={'var(--wp--preset--color--green-700)'}
          def_type={def_type} with_isp_toggle={with_isp_toggle}/>,
        }, {
          text: 'Rotating Residential Proxies',
          id: 'smart_resi',
          content:
        <Pricing_slide id={'smart_resi'} color={'purple'}
          btn_text={'Buy now'} prod_details={['SOCKS5 support',
            '99.99% uptime', 'High anonymity', 'Real Residential IPs',
            'Flat fees, no hidden costs']}
          popular_bg={'var(--wp--preset--color--blue-100)'}
          popular_color={'var(--wp--preset--color--blue-400)'}
          with_need_help={with_need_help}
          with_other_products={with_other_products}
          with_faq={with_faq} def_type={def_type}/>,
        }];
    }, []);
    const periods_data = [{
        text: 'Weekly',
        id: '1w',
    }, {
        text: 'Monthly',
        id: '1m',
    }];
    const initial_best_val = {
        best_badge_top: 60,
        best_badge_left: '80%',
        best_value: <>Best<br/>value</>,
    };
    const [best_val, set_best_val] = useState(initial_best_val);
    const [best_type_pos, set_best_type_pos] = useState(null);
    useEffect(()=>{
        if (width <= 988)
        {
            set_best_val({
                best_badge_top: 46,
                best_badge_left: '84%',
                best_value: <>Best value</>,
            });
        }
        else
            set_best_val(initial_best_val);
        const best_type_el: HTMLElement =
            document.querySelector(`#${best_type}`);
        if (best_type == 'smart_resi')
        {
            set_best_type_pos({
                left: best_type_el?.offsetLeft,
                top: 68,
                p_left: best_type_el?.offsetLeft + 35,
                p_top: -20,
            });
        }
        else
        {
            set_best_type_pos({
                left: best_type_el?.offsetLeft +
                    best_type_el?.offsetWidth / 2 + 12,
                top: 58,
                p_left: best_type_el?.offsetLeft +
                    best_type_el?.offsetWidth / 2 + 47,
                p_top: -14,
            });
        }
    }, [width]);
    return {types_data, slider_data, periods_data, best_val, best_type_pos};
};

interface i_product_hero_props_editor {
    value: i_props_pricing_widget;
    on_change: (v:i_props_pricing_widget)=>void;
    on_cancel: ()=>void;
}

export const Pricing_widget_editor = (props:i_product_hero_props_editor)=>{
    const [state, set_state] = useState<i_props_pricing_widget>(props.value);
    return <Editor
      value={state}
      editors={[
        {key: 'cms_mode', label: 'SET IT TRUE!', type: 'boolean'},
        {key: 'title', label: 'Title', type: 'text'},
        {key: 'title_tag', label: 'Title Tag', type: 'select_tag_selector'},
        {key: 'subtitle', label: 'Sub title', type: 'text'},
        {key: 'type_slider', label: 'type_slider', type: 'boolean'},
        {key: 'def_type',
          label: `def_type: isp|shared_dc|dedicated_dc|isp_plus|smart_resi`,
          type: 'text'},
        {key: 'best_type',
          label: `best_type: isp|shared_dc|dedicated_dc|isp_plus|smart_resi`,
          type: 'text'},
        {key: 'arrow_direction', label: 'arrow_direction: left|right|down',
          type: 'text'},
        {key: 'sliders_pos', label: 'sliders_pos: left|center|right',
          type: 'text'},
        {key: 'with_isp_toggle', label: 'with_isp_toggle', type: 'boolean'},
        {key: 'with_other_products', label: 'with_other_products',
          type: 'boolean'},
        {key: 'with_need_help', label: 'with_need_help', type: 'boolean'},
        {key: 'with_faq', label: 'with_faq', type: 'boolean'},
      ]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}/>;
};

export const Pricing_widget = (props: i_props_pricing_widget)=>{
    const {type_slider = true, def_type, best_type,
        with_faq = false, with_isp_toggle = true,
        with_need_help = false, with_other_products = false,
        title = 'Flexible Proxy Pricing',
        subtitle = 'Choose the perfect proxy plan for your goals',
        cls, sliders_pos = 'center', cms_mode,
    } = props;
    const {T} = use_translation_v({no_defaults: true});
    const {width} = use_screen();
    const {theme} = useContext(Settings_context);
    const {types_data, slider_data, periods_data} = use_widget({def_type,
      with_faq, with_need_help, with_other_products,
      width, best_type, with_isp_toggle});
    return <div className={cls}>
      <div className={cn(theme.container, styles.pricing_container)}>
        {cms_mode ? <Fragment>
          <div className={styles.title}>
          <Dynamic_heading tag={props.title_tag || 'h3'}
            dangerouslySetInnerHTML={{__html: title}}/>
            <p className={cn(theme.med, theme.u2, styles.sub_heading)}
              dangerouslySetInnerHTML={{__html: subtitle}}/>
          </div>
        </Fragment> : <Fragment>
          {(title || subtitle) && <div className={styles.title}>
          <Dynamic_heading tag={props.title_tag || 'h3'}>{title}
          </Dynamic_heading>
            <p className={cn(theme.med, theme.u2, styles.sub_heading)}>
              {subtitle}
            </p>
          </div>}
        </Fragment>}
        <div className={cn(styles.sliders_container, styles[sliders_pos])}>
        <Tooltip cls_cn={styles.tooltip_style} content={
          <div><T>Best value!</T>
          <div className={styles.tooltip_arrow}/></div>}>
          <Switch_slider items={periods_data} qs_param={'period'}/>
        </Tooltip>
        {type_slider && !best_type && !def_type &&
        <Tooltip cls_cn={styles.tooltip_style} content={
          <div><T>Best value!</T>
          <div className={styles.tooltip_arrow}/></div>}>
          <Switch_slider items={types_data} qs_param={'type'}/>
        </Tooltip>}
        </div>
      </div>
      <Full_page_slider type_param={'type'} period_param={'preriod'}
        items={slider_data} def_type={best_type || def_type}/>
    </div>;
};
